module.exports = __webpack_public_path__ + "static/img/ic-check-benefit.32f52d0a.svg";